<template>
  <main>
    <div
      class="recommendations"
      v-if="NewRecommendations && NewRecommendations.length"
    >
      <div class="content">
        <div class="recommendations__head">
          <div class="recommendations__title">Материалы для вас:</div>
          <router-link
            :to="{ name: 'Recommendations' }"
            class="recommendations__button button button_empty-gray d-none d-md-flex"
            >Показать еще</router-link
          >
          <div class="recommendations__arrows">
            <div class="recommendations__arrow recommendations__arrow_left">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.49691e-07 8L7 16L9.5 16L3.5 9L16 9L16 7L3.5 7L9.5 -2.84124e-07L7 -3.93402e-07L3.49691e-07 8Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="recommendations__arrow recommendations__arrow_right">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="recommendations__slider">
          <swiper v-bind="recSwiperSettings" :key="NewRecommendations.length">
            <swiper-slide v-for="(item, ind) in NewRecommendations" :key="ind">
              <RecMaterial @recClick="recClick" :item="item" :hideFavorites="true" />
            </swiper-slide>
          </swiper>
        </div>
        <router-link
          :to="{ name: 'Recommendations' }"
          class="recommendations__button button button_empty-gray d-md-none mt-4 mx-auto"
          >Показать еще</router-link
        >
      </div>
    </div>

    <MainSlider class="mt-8" />
    <section class="therapy-areas main-page__section">
      <div class="content">
        <div class="main-page__row">
          <div class="main-page__categories" data-id="areaItems">
            <div class="main-page__title">Терапевтические области</div>
            <div>
              <div
                class="main-page__categories-row"
                v-if="Nosologys && Nosologys.length"
              >
                <AreaItem
                  v-for="(area, ind) in filteredNos"
                  :key="ind"
                  :item="formattedImageList(area, 'main')"
                  :fastNav="true"
                />
              </div>

              <div v-else class="preloader detail-page__preloader">
                <Preloader class="" />
              </div>
            </div>
          </div>
          <div class="main-page__calendar" data-id="eventsCalendar">
            <div class="main-page__title">Календарь мероприятий</div>
            <Events />
          </div>
        </div>
      </div>
    </section>
    <section class="materials main-page__section">
      <div class="content">
        <div class="main-page__title">Информационные материалы</div>
        <div class="main-page__materials-row">
          <div
            @click="toInfo({ name: 'Library' }, 'Библиотека')"
            class="main-page__material material main-page__library"
          >
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library-mobile.jpg`"
              />
              <source
                media="(max-width: 1220px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library-tablet.jpg`"
              />
              <source
                media="(max-width: 99999999px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library.jpg`"
              />
              <img
                class="material__image"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library.jpg`"
              />
            </picture>

            <div class="material__title">Библиотека</div>
            <div class="material__link">
              Подробнее
              <span class="ml-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            @click="toInfo({ name: 'Podcasts' }, 'Подкасты')"
            class="main-page__material material main-page__podcasts"
          >
            <img
              class="material__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/podcasts.jpg`"
            />
            <div class="material__title">Подкасты</div>
            <div class="material__podcast-title">
              300+ <span>аудио и видеоподкастов <br />для врачей</span>
            </div>
            <div class="material__link">
              Подробнее
              <span class="ml-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            @click="toInfo({ name: 'VideoMaterials' }, 'Видеоматериалы')"
            class="main-page__material material main-page__video material_horizontal"
          >
            <div class="material__title">Видеоматериалы</div>
            <div class="material__text-wrap">
              <div class="material__description">
                Коллекция вебинаров, конференций, интервью и семинаров. Ведущие
                специалисты со всего мира.
              </div>
              <div class="material__link">
                Подробнее
                <span class="ml-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Helper
      v-if="showHelper && helperTargets[currentTarget]"
      @setPosition="setPosition"
      @nextStep="nextStep"
      :target="helperTargets[currentTarget]"
      :position="helperPosition"
      :index="currentTarget"
      :length="helperTargets.length"
      :class="{ topPosition: helperInTop }"
      @close="closeHelp"
    />
  </main>
</template>

<script>
import "swiper/swiper-bundle.css";
import { mapActions, mapGetters } from "vuex";
import AreaItem from "../components/main/AreaItem.vue";
import Events from "../components/main/events/Events.vue";
import MainSlider from "../components/main/MainSliderNew.vue";
import { bus } from "@/main";
import Helper from "@/components/main/Helper.vue";
import Preloader from "@/components/Preloader.vue";
import RecMaterial from "@/components/pageComponents/RecMaterial.vue";
import { Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation]);
import pageVisit from "@/mixins/pageVisit";
export default {
  metaInfo: {
    title: "Информационный портал для работников здравоохранения ",
    description:
      "Цель портала — повысить осведомленность врачей о заболеваниях и современных подходах к терапии",
  },
  components: {
    MainSlider,
    Events,
    AreaItem,
    Helper,
    Preloader,
    RecMaterial,
    Swiper,
    SwiperSlide,
  },
  name: "MainPage",
  mixins: [pageVisit],
  data: () => ({
    recSwiperSettings: {
      noSwiping: true,
      allowTouchMove: false,
      slidesPerView: 4,
      spaceBetween: 32,
      loop: true,
      navigation: {
        nextEl: ".recommendations__arrow_right",
        prevEl: ".recommendations__arrow_left",
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
          noSwiping: false,
          allowTouchMove: true,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1220: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
        // when window width is >= 640px
      },
    },
    helperInTop: false,
    showHelper: false,
    currentTarget: 0,
    helperPosition: {},
  }),
  computed: {
    ...mapGetters(["Nosologys", "user", "NewRecommendations"]),
    helperTargets() {
      return [
        {
          description:
            "Актуальная информация по проблематике и терапии основных заболеваний",
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon1.svg`,
          key: "headerNos",
          position: "bottom",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon2.svg`,
          description:
            "Инструкции по применению и подробные сведения о препаратах «АстраЗенека»",
          key: "headerMed",
          position: "bottom",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon3.svg`,
          description:
            "Научные материалы о заболеваниях и современных подходах к терапии: статьи, видеоролики и подкасты",
          key: "headerLib",
          position: "bottom",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon4.svg`,
          description:
            "Коллекция записей прошедших симпозиумов и предстоящие события «АстраЗенека»",
          key: "headerEvents",
          position: "bottom",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon5.svg`,
          description:
            "Интерактивные материалы по нозологиям, цифровые клиники, тренинги для врачей и многое другое",
          key: "headerProjects",
          position: "bottom",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon7.svg`,
          description:
            "Здесь Вы можете сохранить полезные материалы для быстрого доступа, а также получить уникальные подборки, соответствующие вашим интересам",
          key: "headerCabinet",
          position: "bottom-right",
        },
        {
          icon: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/onboarding/icon6.svg`,
          description: "Быстрый поиск материалов на портале AZ-MOST",
          key: "headerSearch",
          position: "bottom",
        },
      ];
    },
    filteredNos() {
      return this.Nosologys.filter((el) =>
        el.images.find((img) => img.tag === "main")
      );
    },
  },
  methods: {
    ...mapActions(["checkTutorial", "fetchNewRecommendations"]),
    recClick(item) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: item.brands.map((el) => el.title).join(", "),
          brand_id: item.brands.map((el) => el.brand_id).join(", "),
          content_id: item.id || "",
          content_name: item.name,
          content_type: item.type,
          nosology_name: item.disease.map((el) => el.title).join(", "),
          content_parameter: "",
          event_type: "click",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Главная",
          page_type: "",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
    formattedImageList(item, tag) {
      if (item.images && item.images.length) {
        let imageList = [];
        imageList.push({
          src:
            this.$root.host + item.images?.find((el) => el.tag === tag)?.image,
          media: "(max-width: 99999999px)",
        });
        item.image = imageList;
      }

      return item;
    },
    toInfo(to, text) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "main info materials click", {
          "main info materials click": {
            "material name": text,
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(to).catch(() => {});
    },
    startHelp() {
      this.showHelper = true;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "onboarding start", {
          "onboarding start": {
            "banner interaction": "start",
            ...this.$root.ymFields,
          },
        });
        ym(91468266, "reachGoal", "onboarding", {
          onboarding: {
            "/": 1,
            ...this.$root.ymFields,
          },
        });
      }
    },
    closeHelp() {
      this.showHelper = false;
      document.querySelector("body").style.pointerEvents = "";
      document.querySelectorAll(".highlightedElement").forEach((item) => {
        item.classList.remove("highlightedElement");
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      bus.$emit("scrollLock", false);
      this.checkTutorial({ id: this.user.id, flags: ["tutorial"] });
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "onboarding start", {
          "onboarding start": {
            "banner interaction": "skip",
            ...this.$root.ymFields,
          },
        });
      }
    },
    setPosition(target) {
      if (this.$root.isMobile || this.$root.isTablet) {
        if (this.currentTarget === 0) {
          bus.$emit("openMenu");
        }
        if (this.currentTarget === 6) {
          this.helperInTop = false;
          bus.$emit("closeMenu");
        }
        if (this.currentTarget === 5) {
          this.helperInTop = true;
        }
      }
      document.querySelector("body").style.pointerEvents = "none";
      bus.$emit("scrollLock", true);
      let relativePos = {};
      if (!target.key && document.querySelector(`[data-id="${target.key}"]`))
        return;
      let child = document.querySelector(`[data-id="${target.key}"]`);
      let parentPos = document.body.getBoundingClientRect();
      let childPos = child.getBoundingClientRect();
      const yOffset = -100;
      const y =
        child.getBoundingClientRect().top + window.pageYOffset + yOffset;
      if (!target.key.includes("header")) {
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      if (child.closest(".header-menu_mob") && target.key === "headerCabinet") {
        child
          .closest(".header-menu_mob")
          .scrollTo({ top: 300, behavior: "smooth" });
      }

      document.querySelectorAll(".highlightedElement").forEach((item) => {
        item.classList.remove("highlightedElement");
      });
      child.classList.add("highlightedElement");
      relativePos.top = childPos.top + window.scrollY;
      relativePos.right = childPos.right - parentPos.right;
      relativePos.bottom = childPos.bottom - parentPos.bottom;
      relativePos.left = childPos.left;
      relativePos.childWidth = childPos.width;
      relativePos.childHeight = childPos.height;
      this.helperPosition = relativePos;
    },
    nextStep() {
      let routeArray = this.$route.path.split("/");
      if (this.currentTarget < this.helperTargets.length - 1) {
        this.currentTarget++;
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "onboarding", {
            onboarding: {
              [routeArray[routeArray.length - 1] || "/"]:
                this.currentTarget + 1,
              ...this.$root.ymFields,
            },
          });
        }

        this.setPosition(this.helperTargets[this.currentTarget]);
      } else {
        this.showHelper = false;
        document.querySelector("body").style.pointerEvents = "";
        document.querySelectorAll(".highlightedElement").forEach((item) => {
          item.classList.remove("highlightedElement");
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        bus.$emit("scrollLock", false);
        this.checkTutorial({ id: this.user.id, flags: ["tutorial"] });
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "onboarding finish - header", {
            onboarding: {
              finish: "header",
              ...this.$root.ymFields,
            },
          });
        }
      }
    },
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: "",
          brand_id: "",
          content_date: "",
          content_id: "",
          content_name: "",
          content_type: "",
          nosology_name: "",
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Главная",
          page_type: "Главная",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
  created() {
    this.fetchNewRecommendations({
      url: this.$route.path,
      without_rec_cards: "true",
      max_cards: 1000,
    });
  },
  mounted() {
    bus.$on("startHelp", this.startHelp);
    if (this.$route && this.$route.params && this.$route.params.tg) {
      bus.$emit("tgPopup", true);
    }
   
  },
  beforeDestroy() {
    bus.$off("startHelp", this.startHelp);
  },
};
</script>

<style lang="scss" scoped>
.main-page {
  &__row {
    display: grid;
    column-gap: 32px;
    grid-template-columns: 2fr 384px;

    @media screen and (max-width: 1220px) {
      display: block;
    }
  }

  &__section {
    padding-top: 80px;

    @media screen and (max-width: 1220px) {
      padding-top: 40px;
    }
  }

  &__title {
    margin-bottom: 40px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;

    @media screen and (max-width: 1220px) {
      margin-bottom: 32px;
    }
  }

  &__categories-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 32px;
    row-gap: 24px;

    @media screen and (max-width: 767px) {
      column-gap: 16px;
    }
  }

  &__materials-row {
    display: grid;
    grid-template-columns: 492px 692px;
    grid-template-rows: 1fr;
    column-gap: 32px;
    row-gap: 24px;

    @media screen and (max-width: 1220px) {
      display: block;
    }
  }

  &__categories {
    @media screen and (max-width: 1220px) {
      margin-bottom: 40px;
    }
  }
}
.materials {
  & .material {
    position: relative;
    height: 625px;
    padding: 64px;
    display: flex;
    flex-direction: column;
    color: #1f1f1f;
    cursor: pointer;

    &:hover .material__link {
      color: #da338c;
    }

    @media screen and (max-width: 1220px) {
      height: 320px;
      padding: 24px;
      margin-bottom: 16px;
    }

    @media screen and (max-width: 767px) {
      height: 205px;
    }

    &_horizontal {
      flex-direction: row;

      @media screen and (max-width: 1220px) {
        flex-direction: column;
      }
    }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    &__text-wrap {
      max-width: 45%;
      margin-left: auto;
      margin-right: auto;
      border-left: 1px solid #b3bb61;
      padding-left: 62px;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 1220px) {
        margin: auto 0;
        max-width: none;
        border: 0;
        padding: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }

    &__description {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: #1f1f1f;

      @media screen and (max-width: 1220px) {
        margin: auto 0 0;
      }

      @media screen and (max-width: 767px) {
        margin-top: 16px;
        font-size: 14px;
        line-height: 20px;
      }
    }

    &.main-page__video {
      grid-column-start: 1;
      grid-column-end: 3;
      grid-row-start: 2;
      grid-row-end: 3;
      background-color: #c4d600;
      padding-right: 0;
      height: 288px;
      @media screen and (max-width: 1220px) {
        height: 320px;
        padding-right: 24px;
      }

      @media screen and (max-width: 767px) {
        height: 205px;
      }
    }

    &__podcast-title {
      margin: auto 0;
      position: relative;
      z-index: 2;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 450;
      font-size: 211px;
      line-height: 228px;
      color: #830051;

      @media screen and (max-width: 1220px) {
        font-size: 131px;
        line-height: 142px;
        width: fit-content;
      }

      @media screen and (max-width: 767px) {
        font-size: 64px;
        line-height: 78px;
      }

      & span {
        position: absolute;
        bottom: 0;
        right: 0;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #3c4242;

        @media screen and (max-width: 1220px) {
          bottom: auto;
          top: 90%;
        }

        @media screen and (max-width: 1220px) {
          left: 95%;
          right: auto;
          top: 60%;
        }
      }
    }

    &__title {
      position: relative;
      z-index: 2;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 28px;
      line-height: 35px;
      color: inherit;

      @media screen and (max-width: 767px) {
        font-size: 21px;
        line-height: 27px;
      }
    }

    &__link {
      margin-top: auto;
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      transition: 0.3s;
    }
  }
}

.recommendations {
  &__head {
    margin-top: 32px;
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }

  &__button {
    margin-left: auto;
  }

  &__arrows {
    width: fit-content;
    gap: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 24px;
  }

  &__arrow {
    width: 40px;
    height: 40px;
    color: #830051;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #ebefee;
    transition: 0.3s;
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: #830051;
      color: #fff;
    }
  }

  & .swiper-slide {
    height: auto;

    & .material {
      height: 100%;
    }
  }
}
</style>